import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/services/auth.service';
import { IndexedDBService } from 'src/app/indexDB/indexedDB.service';
import { DataService } from 'src/app/shared/services/data.service';
import { NotificationService } from 'src/app/utils/notification.service';
import { UtilityService } from 'src/app/utils/utility.service';
import { environment } from 'src/environments/environment';
import { Permissions } from 'src/app/shared/dto/permissions';
import { PermissionService } from 'src/app/utils/permission.service';
import { InAppNotificationService } from 'src/app/shared/services/in-app-notification.service';
import { NotificationStatsData } from 'src/app/pages/update/models/in-app-notification';
import { TranslationHelperService } from 'src/app/utils/translation-helper.service';
import { MatDialog } from '@angular/material/dialog';
import { ProceedModalComponent } from 'src/app/shared/modals/proceed-modal/proceed-modal.component';

declare var $: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
})
export class HeaderComponent implements OnInit {
  public Permissions = Permissions;
  // notificationList = {
  //   "code": 200,
  //   "message": "Request successful",
  //   "successful": true,
  //   "data": [
  //     {
  //       "id": 15,
  //       "type": "LOAN_APPROVAL",
  //       "title": "Loan pending approval",
  //       "message": "Loan application for John Doe - ₦50,000.00 awaiting approval",
  //       "referenceType": "LOAN_ACCOUNT",
  //       "referenceId": 123,
  //       "status": "UNREAD",
  //       "metadataJson": "{\"clientName\":\"John Doe\",\"amount\":50000.00,\"accountNumber\":\"0000000123\"}",
  //       "createdAt": "2025-02-01T10:30:00",
  //       "readAt": null,
  //       "actionUrl": "/loans/123"
  //     },
  //     {
  //       "id": 15,
  //       "type": "LOAN_APPROVAL",
  //       "title": "Loan pending approval",
  //       "message": "Loan application for John Doe - ₦50,000.00 awaiting approval",
  //       "referenceType": "LOAN_ACCOUNT",
  //       "referenceId": 123,
  //       "status": "UNREAD",
  //       "metadataJson": "{\"clientName\":\"John Doe\",\"amount\":50000.00,\"accountNumber\":\"0000000123\"}",
  //       "createdAt": "2025-02-01T10:30:00",
  //       "readAt": null,
  //       "actionUrl": "/loans/123"
  //     },
  //     {
  //       "id": 15,
  //       "type": "LOAN_APPROVAL",
  //       "title": "Loan pending approval",
  //       "message": "Loan application for John Doe - ₦50,000.00 awaiting approval",
  //       "referenceType": "LOAN_ACCOUNT",
  //       "referenceId": 123,
  //       "status": "UNREAD",
  //       "metadataJson": "{\"clientName\":\"John Doe\",\"amount\":50000.00,\"accountNumber\":\"0000000123\"}",
  //       "createdAt": "2025-02-01T10:30:00",
  //       "readAt": null,
  //       "actionUrl": "/loans/123"
  //     },
  //     {
  //       "id": 15,
  //       "type": "LOAN_APPROVAL",
  //       "title": "Loan pending approval",
  //       "message": "Loan application for John Doe - ₦50,000.00 awaiting approval",
  //       "referenceType": "LOAN_ACCOUNT",
  //       "referenceId": 123,
  //       "status": "UNREAD",
  //       "metadataJson": "{\"clientName\":\"John Doe\",\"amount\":50000.00,\"accountNumber\":\"0000000123\"}",
  //       "createdAt": "2025-02-01T10:30:00",
  //       "readAt": null,
  //       "actionUrl": "/loans/123"
  //     },
  //     {
  //       "id": 14,
  //       "type": "REPAYMENT_APPROVAL",
  //       "title": "Repayment pending approval",
  //       "message": "Repayment of ₦25,000.00 for Jane Smith - Loan 0000000456 awaiting approval",
  //       "referenceType": "REPAYMENT_APPROVAL",
  //       "referenceId": 89,
  //       "status": "UNREAD",
  //       "metadataJson": "{\"clientName\":\"Jane Smith\",\"amount\":25000.00,\"accountNumber\":\"0000000456\"}",
  //       "createdAt": "2025-02-01T09:15:00",
  //       "readAt": null,
  //       "actionUrl": "/repayment-approvals/89"
  //     },
  //     {
  //       "id": 12,
  //       "type": "LOAN_DISBURSEMENT_PENDING",
  //       "title": "Loan disbursement pending",
  //       "message": "Loan disbursement of ₦100,000.00 for Sarah Williams is pending payment gateway confirmation",
  //       "referenceType": "LOAN_ACCOUNT",
  //       "referenceId": 789,
  //       "status": "READ",
  //       "metadataJson": "{\"clientName\":\"Sarah Williams\",\"amount\":100000.00,\"accountNumber\":\"0000000789\"}",
  //       "createdAt": "2025-01-31T14:20:00",
  //       "readAt": "2025-01-31T14:25:00",
  //       "actionUrl": "/loans/789"
  //     }
  //   ],
  //   "pagination": {
  //     "totalElements": 15,
  //     "totalPages": 1,
  //     "isFirst": true,
  //     "isLast": true,
  //     "page": 0,
  //     "pageSize": 20
  //   }
  // }

  @Output() toggleSideNavEmit: EventEmitter<any> = new EventEmitter();
  @Output() sendNotificationEmit: EventEmitter<any> = new EventEmitter();
  @Input() showMobileToggler: boolean;
  @Input() u: any = {};
  @Input() isSideNavCollapsed: boolean = false;

  public baseUrl: string = environment.baseUrl;
  public _notifications: any = [];
  public hasNotification: boolean = false;
  public notificationStats: NotificationStatsData | null = null;

  notificationTypeOptions = [
    { id: 1, label: 'All Types', value: 'ALL' },
    { id: 2, label: 'Loan Approvals', value: 'LOAN_APPROVAL' },
    { id: 3, label: 'Repayments', value: 'REPAYMENT_APPROVAL' },
    { id: 4, label: 'Others', value: 'OTHER' },
  ];

  selectedNotificationType = 'ALL';
  activeTab: 'ALL' | 'UNREAD' = 'ALL';

  constructor(
    private utilsService: UtilityService,
    private dataService: DataService,
    private router: Router,
    private _auth: AuthService,
    private toast: NotificationService,
    private iDBService: IndexedDBService,
    private permissionService: PermissionService,
    private inAppNotificationService: InAppNotificationService,
    private translateHelper: TranslationHelperService,
    private dialog: MatDialog,
  ) {}

  // open/close side menu... Emitted in Main Component
  public toggleSideNav() {
    this.toggleSideNavEmit.emit();
  }

  // populate notifications on app load before subscribing to websocket
  private getNotifications() {
    this.utilsService.currentNotifications.subscribe((data) => {
      if (data !== undefined) {
        this._notifications = data.notifications;
        this.hasNotification = true;
      }
    });
  }

  //
  public sendNotification(data) {
    this.sendNotificationEmit.emit(data);
    this.removeNotification(data.notificationType);
  }
  public removeNotification(data) {
    this.dataService.deleteANotification({ notificationType: data }).subscribe(
      (status) => {
        if (status.code !== 0) {
          this.toast.error(
            this.translateHelper.translateBackendMessage(status.message),
          );
        }
      },
      (error) => {
        this.toast.error(
          this.translateHelper.translateBackendMessage(
            'An error occured when deleting notification.',
          ),
        );
      },
    );
  }

  public logout(): void {
    const dialogRef = this.dialog.open(ProceedModalComponent, {
      disableClose: true,
      data: {
        message: $localize`:@@logout_confirmation:Are you sure you want to logout?`,
        proceedVal: {
          name: $localize`:@@logout:Logout`,
          class:
            'p-3 rounded-xl text-white bg-error/90 hover:bg-error w-[150px]',
        },
      },
    });

    dialogRef.afterClosed().subscribe((confirmed) => {
      if (!confirmed) return;
      this._auth.logout().subscribe({
        next: () => {
          this.toast.success(
            this.translateHelper.translateBackendMessage(
              'User logged out successfully',
            ),
          );
          this.iDBService.deleteDatabase();
          // Hard-reload so all root-scoped Angular singletons reset
          // alongside AuthService — router.navigate keeps them alive.
          location.href = '/login';
        },
        error: (err) => {
          localStorage.clear();
          this.toast.success(
            this.translateHelper.translateBackendMessage(
              'User logged out successfully',
            ),
          );
          location.href = '/login';
        },
      });
    });
  }

  private onInit() {
    this.u = this._auth.getuser;
    this.getNotifications();
    this.getNotficationStats();
  }

  ngOnInit(): void {
    this.onInit();
  }

  getNotficationStats() {
    this.inAppNotificationService.getUserInAppNotificationStats().subscribe({
      next: (res) => {
        this.notificationStats = res.data;
      },
      error: (err) => {
        console.error('Error fetching notification stats', err);
      },
    });
  }

  onTabChange(index: number) {
    this.activeTab = index === 0 ? 'ALL' : 'UNREAD';
  }
  // Mark all notifications as read
  // markAllAsRead() {
  //   this.notificationList.data.forEach(n => n.status = 'READ');
  //   // Call your backend API to update read status
  //   this.notificationList.data.forEach(n => this.removeNotification(n.type));
  // }

  // Open notification
  openNotification(item) {
    if (item.status === 'UNREAD') {
      item.status = 'READ';
      this.removeNotification(item.type); // mark read on backend
    }

    // Navigate if needed
    if (item.type === 'LOAN_APPROVAL') this.router.navigate(['/support']);
    else if (item.type === 'REPAYMENT_APPROVAL') this.router.navigate(['/kyc']);
    else this.sendNotification(item);
  }

  gotoNotificationPage() {
    this.router.navigate(['/updates']);
  }

  // Notifications for the tabs
  // get allNotifications() {
  //   return this.filteredNotifications;
  // }

  // get filteredNotifications() {
  //   let list = this.notificationList?.data || [];

  //   // filter by type
  //   if (this.selectedNotificationType !== 'ALL') {
  //     if (this.selectedNotificationType === 'OTHER') {
  //       list = list.filter(
  //         n => n.type !== 'LOAN_APPROVAL' && n.type !== 'REPAYMENT_APPROVAL'
  //       );
  //     } else {
  //       list = list.filter(n => n.type === this.selectedNotificationType);
  //     }
  //   }

  //   return list;
  // }

  // get unreadNotifications() {
  //   return this.filteredNotifications.filter(n => n.status === 'UNREAD');
  // }

  // get selectedNotificationTypeLabel(): string {
  //   const found = this.notificationTypes.find(
  //     t => t.value === this.selectedNotificationType
  //   );
  //   return found ? found.label : 'All Types';
  // }

  onNotificationTypeChange(option: any) {
    if (!option) return;

    // your component emits {label, value} OR option object
    this.selectedNotificationType = option.value ?? 'ALL';
  }
}
